import { useMemo } from "react";
import { Grid } from "@jsq/ds/core";
import { useGetCountriesQuery } from "~/graphql/supergraphHooks";
import { buildCountryCodeToNameMap } from "../../utils/countryCodeToName";
import { columnDefs, gridOptions, type GridContext } from "./gridConfig";
import * as styles from "./styles_vanilla.css";
import type { ControllingPersonEntry } from "../../types";

type ControllingPersonsTableProps = {
  entries: ControllingPersonEntry[];
  onEdit: (entry: ControllingPersonEntry) => void;
  onDelete: (entryId: string) => void;
  readonly?: boolean;
};

export const ControllingPersonsTable = ({
  entries,
  onEdit,
  onDelete,
  readonly = false,
}: ControllingPersonsTableProps) => {
  const { data } = useGetCountriesQuery();
  const countryCodeToName = useMemo(
    () => buildCountryCodeToNameMap(data?.complianceCountries),
    [data?.complianceCountries],
  );

  const context: GridContext = useMemo(
    () => ({
      getCountryName: (code: string) => countryCodeToName[code] || code,
      onEdit,
      onDelete,
      readonly,
    }),
    [countryCodeToName, onEdit, onDelete, readonly],
  );

  if (entries.length === 0) return null;

  return (
    <div className={styles.tableWrapper}>
      <Grid<ControllingPersonEntry>
        gridOptions={gridOptions}
        rowData={entries}
        columnDefs={columnDefs}
        context={context}
        getRowId={(params) => params.data.id}
      />
    </div>
  );
};
